import React from 'react';
import { Routes } from 'react-router-dom';
import ErrorBoundary from '@/components/ui/error-boundary';
import SEOHead from '@/components/seo/SEOHead';
import {
  CoreRoutes,
  EmergencyRoutes,
  MaintenanceRoutes,
  PropertyRoutes,
  RootAndStandaloneRoutes,
  TenantRoutes,
  VendorRoutes,
} from './StandaloneRouteSectionsPrimary';
import {
  AdminRoutes,
  AIRoutes,
  ManagementRoutes,
  PublicAndFallbackRoutes,
} from './StandaloneRouteSectionsPlatform';

const StandaloneRoutes = () => {
  return (
    <ErrorBoundary>
      <SEOHead />
      <Routes>
        {RootAndStandaloneRoutes()}
        {CoreRoutes()}
        {PropertyRoutes()}
        {VendorRoutes()}
        {MaintenanceRoutes()}
        {EmergencyRoutes()}
        {TenantRoutes()}
        {ManagementRoutes()}
        {AIRoutes()}
        {AdminRoutes()}
        {PublicAndFallbackRoutes()}
      </Routes>
    </ErrorBoundary>
  );
};

export default StandaloneRoutes;
